import { GoogleOAuthProvider } from '@react-oauth/google';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Slide, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import App from './App.js';
import { AuthProvider } from './api/AuthContext.js'; // Adjust the path as needed
import { initializePaddle } from './api/subscriptions.js';
import reportWebVitals from './reportWebVitals.js';
import * as serviceWorkerRegistration from './serviceWorkerRegistration.js';

import { ConfigProvider } from 'antd';

import './i18n.js';

// Initialize Paddle.js when app loads
if (typeof window !== 'undefined') {
    window.addEventListener('load', () => {
        initializePaddle();
    });
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <GoogleOAuthProvider clientId="221885170075-ab0dcntt68a3rsbrql40b7enth0i3ao8.apps.googleusercontent.com">
        <React.StrictMode>
            <BrowserRouter>
                <AuthProvider>
                    <ToastContainer
                        position="bottom-center"
                        autoClose={1000}
                        hideProgressBar
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="light"
                        transition={Slide}
                    />
                    <ConfigProvider
                        theme={{
                            token: {
                                // Seed Token
                                colorPrimary: '#04D1B2',
                                borderRadius: 4,
                            },
                        }}
                    >
                        <App />
                    </ConfigProvider>
                </AuthProvider>
            </BrowserRouter>
        </React.StrictMode>
    </GoogleOAuthProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
